import * as webeditor from '../../../../webeditor/biokb-editor-adapters';
import {SearchData} from '../common/sidebar-search-field/interface';
import {SearchHistoryRecordDto} from './hooks/requests/use-explore-view-search-history-query';
import {isSearchCategory, isSearchNode} from '../common/sidebar-search-field/suggestion-helpers';

function getWholeNodeText(accession: string, usage: webeditor.UsageNode) {
    return webeditor
        .getHtmlForUsageJSON(accession, usage)
        .then((e) => e.innerText.replace('\n', ''));
}

export const parseNodes = (
    accession: string,
    usages: webeditor.UsageNode[]
): Promise<DocumentNode[]> => {
    return Promise.all(
        usages.map(async (usage) => {
            return {
                id: webeditor.getNodeIdOfResolvedNode(usage.node),
                label: await getWholeNodeText(accession, usage)
            };
        })
    );
};

export function convertSearchDataToSearchHistoryRecord(
    searchData: SearchData
): SearchHistoryRecordDto | null {
    if (isSearchCategory(searchData)) {
        return {
            stringSearch: null,
            referencedNode: null,
            categoriesSearch: {
                categories: [{name: searchData.name, categoryId: searchData.categoryId}],
                includeUncategorized: false
            }
        };
    }

    if (isSearchNode(searchData) && searchData.documentAccession && searchData.nodeId) {
        return {
            stringSearch: null,
            categoriesSearch: null,
            referencedNode: {
                accession: searchData.documentAccession,
                nodeId: searchData.nodeId,
                type: searchData.nodeType,
                name: searchData.name
            }
        };
    }

    return null;
}

export function convertHistoryRecordToSearchData(
    historyRecord: SearchHistoryRecordDto
): SearchData {
    if (historyRecord.referencedNode) {
        return {
            type: 'node',
            nodeType: historyRecord.referencedNode.type,
            nodeId: historyRecord.referencedNode.nodeId,
            name: historyRecord.referencedNode.name,
            documentAccession: historyRecord.referencedNode.accession
        };
    }

    if (historyRecord.stringSearch) {
        return {
            type: 'document',
            searchString: historyRecord.stringSearch.value
        };
    }

    if (historyRecord.categoriesSearch) {
        return {
            type: 'category',
            categoryId: historyRecord.categoriesSearch.categories[0].categoryId,
            name: historyRecord.categoriesSearch.categories[0].name
        };
    }

    throw new Error('Unknown history record type');
}

export function getHistoryRecordType(
    historyRecord: SearchHistoryRecordDto
): Pick<SearchData, 'type'>['type'] {
    if (historyRecord.stringSearch) {
        return 'document';
    }

    if (historyRecord.categoriesSearch) {
        return 'category';
    }

    if (historyRecord.referencedNode) {
        return 'node';
    }

    throw new Error('Unknown history record type');
}
